import { render } from "./NewNotificationModal.vue?vue&type=template&id=ec663214&scoped=true"
import script from "./NewNotificationModal.vue?vue&type=script&lang=js"
export * from "./NewNotificationModal.vue?vue&type=script&lang=js"

import "./NewNotificationModal.vue?vue&type=style&index=0&id=ec663214&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec663214"]])

export default __exports__